import { createRoot } from 'react-dom/client';
import { getFunctions, httpsCallable } from 'firebase/functions';

// HEADS UP: this is the change that makes cs106a website
// different than code in place. It should only be
// set to cs106a in the cs106a branch.
// import {Router} from 'csbridge/Router'
// import { Router } from 'cs106a/Router';
import { Router } from './Router';
import { NavigationHistoryProvider } from 'contexts/NavigationContext';
import { TimeProvider } from 'contexts/TimeContext';

// disable console.log in production.
// console.warn and console.error will log to firebase
const container = document.getElementById('root');
const root = createRoot(container);

// Simple wrapper to show loader immediately
function Application() {
 

  return (
        <NavigationHistoryProvider>
          <TimeProvider>
                <Router />
          </TimeProvider>
        </NavigationHistoryProvider>
  );
}

root.render(
    <Application />
);
